export default __webpack_public_path__ + "static/media/partner_logo_17.4f4434c6.png";